<template lang="pug">
  v-main
    v-container
        v-card
            v-toolbar(class="elevation-0" color='white')
                v-toolbar-title Create New
            v-divider
            v-card-text
                v-row(no-gutters)
                    v-col(cols="4") 
                        v-subheader(color="black")
                            span(style="color: #D42A2A;") *
                            | &nbsp;Alias Name&nbsp;
                            span(style="font-size:.7rem; color: #909090") (Required)
                    v-col(cols="5")
                        v-text-field(
                            v-model='bu.alias' 
                            label='Alias'
                            :rules="[rules.required]"
                            @keypress="isLetter($event)"
                        )

                v-row(no-gutters)
                    v-col(cols="4") 
                        v-subheader(style="height: 16px;") 
                            span(style="color: #D42A2A;") *
                            | &nbsp;Business Unit Email&nbsp;
                            span(style="font-size:.7rem; color: #909090") (Required)
                        small(style="color: #F08703;" class="ml-4") *Email for notification memo 
                    v-col(cols="5")
                        v-text-field(
                            v-model='bu.email' 
                            label="Email (Don't use personal e-mail)",
                            type="email" 
                            :rules="[rules.required, rules.email]"
                        )

                v-row(no-gutters)
                    v-col(cols="4") 
                        v-subheader(style="height: 16px;")
                            | &nbsp;Business Unit Phone Number&nbsp;
                            span(style="font-size:.7rem; color: #909090") (Optional)
                        small(style="color: #F08703;" class="ml-4") *Phone number for notification memo
                    v-col(cols="5")
                        vue-tel-input(
                            @validate="telValidate" 
                            v-model="bu.msisdn"
                            style="border-top: none; box-shadow: none; border-right: none; border-left: none; border-bottom: 2px solid;"
                        )
                        p(style="color: #ff5252; margin: 0; font-size: 12px;" v-if="bu.msisdn.length > 0 && !validNumber") invalid Phone Number Format


                v-row(no-gutters)
                    v-col(cols="4") 
                        v-subheader 
                            span(style="color: #D42A2A;") *
                            | &nbsp;Position&nbsp;
                            span(style="font-size:.7rem; color: #909090") (Required)
                    v-col(cols="5")
                        v-text-field(
                            v-model='bu.position' 
                            label='Position' 
                            :rules="[rules.required]"
                        )

                v-row(no-gutters)
                    v-col(cols="4") 
                        v-subheader 
                            span(style="color: #D42A2A;") *
                            | &nbsp;Business Unit&nbsp;
                            span(style="font-size:.7rem; color: #909090") (Required)
                    v-col(cols="5")
                        v-autocomplete(
                            ref="bu.bisnis_unit"
                            v-model="bu.bisnis_unit"
                            :rules="[() => !!bu.bisnis_unit || 'This field is required.']"
                            :items="bisnis_units"
                            item-text="name"
                            item-value="_id"
                            label="Business Unit"
                            placeholder="Select"
                            required)

                v-card-actions(class="my-8")
                    v-btn(class="custom__padding-btn" @click="onBack()") Back
                    v-btn(
                        color='blue-secondary' 
                        class="custom__padding-btn" 
                        :disabled="!formIsValid"
                        @click="create()") Create
    
    v-overlay(:value="overlay")
      v-progress-circular(
        indeterminate
        size="64"
      )
</template>

<script>
import axios from 'axios';
import { mapState } from "vuex";
export default {
  data: () => ({
    validNumber:  false,
    bu: {
        alias: '',
        email: '',
        msisdn: '',
        position: '',
        bisnis_unit: '',
        is_active: true,
        is_admin: true
    },
    bisnis_units: [],
    rules: {
        required: value => !!value || 'This field is required.',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid email format'
        },
        msisdn: value => (value && value.length >= 10) || 'Mobile number cannot be less than 10',
    },
    overlay: false
  }),
  mounted(){
    this.getBisnisUnit()
    this.bu.alias = this.$route.query.alias || ""
    this.bu.email = this.$route.query.mail || ""
    this.bu.msisdn = this.$route.query.phone != "null" ? this.$route.query.phone : ""
    this.bu.position = this.$route.query.position || ""
  },
  computed: {
    ...mapState(["loadingData", "showDrawer"]),
    formIsValid () {
      return (
        this.bu.alias &&
        this.bu.email &&
        (this.validNumber || this.bu.msisdn.length == 0) &&
        this.bu.position && 
        this.bu.bisnis_unit
      )
    },
  },
  methods: {
    telValidate(telnumber) {  
        if (telnumber.valid || this.bu.msisdn.length == 0) this.validNumber = true  
        else  this.validNumber = false
    },
    create() {
        this.overlay = true;
        this.$store.dispatch("addBisnisUnitToUsers", { bu:this.bu, user_id: `${this.$route.params.id}` })
        .then(res => {
            this.overlay = false
            if (this.showDrawer) this.$store.commit("toggleDrawer");
                this.$toasted.success("Success, account added successfully", { icon : 'check_circle'});

                this.$router.push({
                    name: "Users Detail",
                    params: { id: `${this.$route.params.id}` },
                });
        })
        .catch(err => {
            this.overlay = false
            this.$toasted.error(err.response.data.message, { icon : 'error'})
        });
    },
    getBisnisUnit(){

        let token = localStorage.getItem('token');
        axios.get(process.env.VUE_APP_API+`/business-unit/list/active`,
        {
            headers: { Authorization: `Bearer ${token}` }
        })
        .then(res => {
            this.bisnis_units = res.data.data
        })
        .catch(err => {
        })
        .finally(() => (this.loading = false));

    },
    onBack(){
        this.$router.push({
            name: "Users Detail",
            params: { id: `${this.$route.params.id}` },
        });
    },
    isNumber(e) {
        let char = String.fromCharCode(e.keyCode); 
        if(/^[0-9]+$/.test(char)) return true; 
        else e.preventDefault(); 
    },
    isLetter(e) {
        let char = String.fromCharCode(e.keyCode); 
        if(/^[A-Za-z0-9 ]+$/.test(char)) return true; 
        else e.preventDefault(); 
    }
  }

};
</script>

<style>
    button.custom__padding-btn{
        padding: 1.4rem 2rem !important;
    }

    .v-toolbar__content {
        box-shadow: none;
    }
</style>